import { memo } from 'react'
import { ProjectTaskTable } from './components/projectTaskTable/projectTaskTable'

export const ProjectDetailTaskListDataGrid = memo(() => {
  return <ProjectTaskTable />
})
